export const createBase64Text = (
  size: { w: number; h: number },
  font: string,
  text: string,
  position: { x: number; y: number }
) => {
  const canvas = document.createElement("canvas");
  canvas.width = size.w;
  canvas.height = size.h;

  const ctx = canvas.getContext("2d");
  ctx!.font = font;
  ctx!.fillText(text, position.x, position.y);

  return canvas.toDataURL("image/png");
};
